import React from "react";
import TextField, { TextFieldProps } from "./TextField";

const bannedXssCharacters = "<>/\\\"'";

export interface AntiXssTextFieldProps extends TextFieldProps {}

const AntiXssTextField: React.FC<AntiXssTextFieldProps> = (props) => {
    const onChange = (value: string) => {
        const newCharacter = value.slice(-1);
        if (newCharacter !== "" && bannedXssCharacters.includes(newCharacter)) {
            return;
        }

        props.handleDataChange(value);
    };

    return <TextField {...props} handleDataChange={onChange} />;
};

export default AntiXssTextField;
